import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import '../../../modules/companies/register-panels'
import '../../../modules/contacts/register-panels'
import '../../../modules/engagement/register-panels'
import { EngagementEventsView } from '../../../modules/engagement/engagement-events-view'
import { PANEL_TYPES } from '../../../shell/panel-state'

const eventsSearchSchema = z.object({
  q: z.string().optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
  pstack: z.string().optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
})

export const Route = createFileRoute('/_authed/engagement/events')({
  validateSearch: eventsSearchSchema,
  component: EngagementEventsRoute,
})

function EngagementEventsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <EngagementEventsView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => {
            const next: Record<string, unknown> = { ...prev, ...patch }
            for (const [key, value] of Object.entries(next)) {
              if (value == null || value === '') delete next[key]
            }
            return next
          }) as never,
          replace: true,
        })
      }
    />
  )
}
